import * as React from "react";
import type { SVGProps } from "react";
const SvgStar01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M10.891 3.172c.381-1.03 1.837-1.03 2.218 0l1.896 5.124c.12.324.375.58.699.699l5.124 1.896c1.03.38 1.03 1.837 0 2.218l-5.124 1.896c-.324.12-.58.375-.699.699l-1.896 5.124c-.38 1.03-1.837 1.03-2.218 0l-1.896-5.124a1.18 1.18 0 0 0-.699-.699L3.172 13.11c-1.03-.381-1.03-1.837 0-2.218l5.124-1.896c.324-.12.58-.375.699-.699z"
    />
  </svg>
);
export default SvgStar01;
